import { FC } from '../../Services'
import quotesType from '../../State/quotesType'
import { showToast } from '../../utils/toast'
export const alert = showToast
export const services = quotesType

export const prepareOptionsFilters = (type) => services.find((obj) => obj.id === type).filters

/**
 * This function processes an array `servicePriority` by mapping each offerType to a promise that
 * retrieves service information associated with that offerType. It returns an array of objects,
 * maintaining the original order of `servicePriority`, where each object has a key as `offerType`
 * and value as an array of codes obtained from the service response after splitting it by commas.
 *
 * @async
 * @function prepareServicePriority
 * @returns {Promise<Array<Object>>} A promise that resolves to an array of objects, each containing
 *                                   an offerType as the key and associated service codes as the value.
 * @throws Will log an error to the console if an error occurs.
 */
export const prepareServicePriority = async (servicePriority) => {
  try {
    // Restituisce l'array di oggetti mantenendo l'ordine originale di servicePriority.
    return await Promise.all(
      servicePriority.map(async (service) => {
        const result = await FC.service('info').get('getTrainOffer', {
          query: { offerType: service.id }
        })
        return { ...service, codes: result.split(',') }
      })
    )
  } catch (error) {
    throw new Error(error)
  }
}

const prepareFilter = (filter, value, flagAbilitazione, valuesRimborso, valuesNoRimborso) => {
  const result = { ...filter, value }

  if (flagAbilitazione) {
    if (valuesRimborso !== null) {
      result.rimborsabili = valuesRimborso
    }
    if (valuesNoRimborso !== null) {
      result.nonRimborsabili = valuesNoRimborso
    }
  }

  return result
}

export const prepareSelectedFilters = (
  selectedFilters,
  inputValues,
  flagAbilitazione,
  inputRimborso,
  inputNoRimborso
) =>
  selectedFilters.map((filter, index) =>
    prepareFilter(
      filter,
      inputValues[index] || 0,
      flagAbilitazione,
      inputRimborso?.length ? inputRimborso[index] || 0 : null,
      inputNoRimborso?.length ? inputNoRimborso[index] || 0 : null
    )
  )

/**
 * Toglie il flag di default alla community che ha settato default a true.
 *
 * Questa funzione controlla se `initialDefaultPreset` è falso e se `defaultPreset` è disponibile.
 * Se queste condizioni sono soddisfatte, cerca una community di default associato all'ambiente dell'utente corrente.
 * Se trova una community di default, aggiorna il suo stato e imposta `initialDefaultPreset` a vero.
 *
 * @param {Object} defaultPreset - L'oggetto preset di default attuale.
 * @param {boolean} initialDefaultPreset - Flag che indica se il preset di default iniziale è stato impostato.
 * @param {Function} setInitialDefaultPreset - Funzione per aggiornare lo stato di `initialDefaultPreset`.
 * @async
 * @autore mranocchia
 */
export const prepareDefaultPreset = async (
  defaultPreset,
  initialDefaultPreset,
  setInitialDefaultPreset,
  environmentId
) => {
  if (!initialDefaultPreset && defaultPreset) {
    const presetDefault = await FC.service('communityPreset').find({
      query: { defaultPreset: 1, environmentId }
    }) // cerco il preset di default con environment id dell'utente e defaultPreset = 1
    if (presetDefault[0]) {
      await FC.service('communityPreset').patch(presetDefault[0].id, { defaultPreset: 0, state: 0 })
      setInitialDefaultPreset(true)
    }
  }
}

export const setSelectedFilters = (
  filters,
  setInputValues,
  setSelectedFilters,
  setInputRimborso,
  setInputNoRimborso
) => {
  const inputValues = []
  const inputRimborso = []
  const inputNoRimborso = []

  const selectedFilters = filters.map((element) => {
    inputValues.push(element.value)
    inputRimborso.push(element.rimborsabili)
    inputNoRimborso.push(element.nonRimborsabili)

    const { value, ...rest } = element
    return rest
  })

  setInputValues(inputValues)
  setInputRimborso && setInputRimborso(inputRimborso)
  setInputNoRimborso && setInputNoRimborso(inputNoRimborso)
  setSelectedFilters(selectedFilters)
}
